<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH"><span class="ePub-B">CONTENTS</span></p>
<p class="CFMH"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="CFMH"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="CFMH"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="CCT"> </p>
<p class="CFMH"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="CCT">  1. <a href="#/xhtml/chapter1#ch1">Champagne Wishes and Clam-Free Dreams</a></p>
<p class="CCT">  2. <a href="#/xhtml/chapter2#ch2">Room to Romp</a></p>
<p class="CCT">  3. <a href="#/xhtml/chapter3#ch3">The Day My Tipsy Dad Went Punk and Hit My Mom (Or, My Year in TV Movies)</a></p>
<p class="CCT">  4. <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Coming of Stage</span></p>
<p class="CCT">  5. <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Being Clarissa</span></p>
<p class="CCT">  6. <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Is That Teen Spirit I Smell?</span></p>
<p class="CCT">  7. <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Straight from the Hart</span></p>
<p class="CCT">  8. <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Moms Do the Darndest Things</span></p>
<p class="CCT">  9. <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">An A for Effort</span></p>
<p class="CCT">10. <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Abracadabra! Another Hit!</span></p>
<p class="CCT">11. <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Just Say “Why Not?”</span></p>
<p class="CCT">12. <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">The One That Never Got Away</span></p>
<p class="CCT">13. <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Our Traveling Family Circus</span></p>
<p class="CCT">14. <span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">It’s All About the Canapés, Baby</span></p>
<p class="CCT">15. <span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Are You Ready for Some Football?</span></p>
<p class="CCT">16. <span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Four Things I Never Learned to Do for Myself</span></p>
<p class="CCT">17. <span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">When Mommy’s Worlds Collide</span></p>
<p class="CCT">18. <span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Abnormally Normal</span></p>
<p class="CCT"> </p>
<p class="CBMH"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="CBMH"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="CBMH"><span href="#/xhtml/photo1#pho" title="Link target outside of Sample">Photographs</span></p>
<p class="CBMH"><span href="#/xhtml/abouttheauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="CBMH"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1265438d